import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';

const ConditionCard = ({ title, children }) => {
  return (
    <Card variant="outlined">
      <CardContent sx={{ paddingBottom: '16px !important' }}>
        <Grid container spacing={2} alignItems="center">
          {title && (
            <Grid item>
              <Typography sx={{ fontSize: 14, fontWeight: 'bold' }} color="text.secondary">
                {title}
              </Typography>
            </Grid>
          )}
          {children}
        </Grid>
      </CardContent>
    </Card>
  );
};

ConditionCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ConditionCard.defaultProps = {
  title: null,
};

export default ConditionCard;
